import t, { useEffect as x } from "react";
import { useTranslation as F } from "react-i18next";
import D from "../../../hooks/customization/useCustomization.js";
import { Autocomplete as B } from "../../../../../../features/google/components/Autocomplete/Autocomplete.js";
import { TextInput as w } from "../../../../../../features/common/components/forms/TextInput/TextInput.js";
import { Status as O } from "../../../../../../../common/shared/status.js";
import { ServiceType as p, ServiceMapNames as f } from "../../../../../../../common/shared/serviceType.js";
import { useAddressServiceAction as R } from "../hooks/useAddressServiceAction.js";
import { useOrdering as V } from "../context.js";
import s from "./steps.module.scss.js";
import { getCacheStorePrefix as P } from "../shared.js";
import { AddressValidationStatus as l } from "../../../shared/address-validation-status.enum.js";
function X({
  autocomplete: g
}) {
  var v, A;
  const {
    form: n,
    setStep: L,
    setFormValue: u,
    setErrors: m,
    errors: a
  } = V(), { t: o } = F(), {
    configuration: r,
    getTextTranslations: k
  } = D(), C = ((v = n.place) == null ? void 0 : v.addressComponents.some((d) => d.types.includes("street_number"))) ?? !1, {
    proceed: S,
    isLoading: h
  } = R(), e = k("popup"), E = (d) => r == null ? void 0 : r.settings.configuration.scope.some((c) => {
    var i, T;
    return ((T = (i = c == null ? void 0 : c.services) == null ? void 0 : i[f[d]]) == null ? void 0 : T.status) === O.ENABLED;
  }), b = E(p.TAKEAWAY), _ = E(p.DELIVERY), I = !_ && !b;
  x(() => {
    var d, c, i;
    if (((d = a.address) == null ? void 0 : d.platform) !== void 0)
      switch ((c = a.address) == null ? void 0 : c.platform.type) {
        case l.SUSPENDED:
          m({
            address: {
              textError: (e == null ? void 0 : e.error_suspended) || o("shopLanding.address.error.suspended")
            }
          });
          break;
        case l.LOCATION_TEMPORARILY_UNAVAILABLE:
          m({
            address: {
              textError: (e == null ? void 0 : e.error_location_temporaly_unavailable) || o("shopLanding.address.error.locationTemporarilyUnavailable")
            }
          });
          break;
        case l.OUT_OF_RANGE:
        case l.NOT_POSSIBLE_TO_DELIVER:
        case l.NO_DRIVERS_AVAILABLE:
          L({
            name: "no-reach",
            data: {
              restaurants: (i = a.address) == null ? void 0 : i.platform.restaurants
            }
          });
          break;
        case l.INVALID_ADDRESS:
        case l.INVALID_CONTACT_DATA:
          m({
            address: {
              textError: (e == null ? void 0 : e.error_invalid_address) || o("shopLanding.address.error.invalidAddress")
            }
          });
          break;
        default:
          m({
            address: {
              textError: (e == null ? void 0 : e.error_unknown) || o("shopLanding.address.error.unknown")
            }
          });
      }
  }, [a]);
  const y = async (d) => {
    await S(d, n);
  }, N = typeof (window == null ? void 0 : window.customCoordinates) == "object" ? window.customCoordinates : void 0;
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { "data-testid": "address-step", className: s.formTitle }, (e == null ? void 0 : e.title) || o("shopLanding.address.title")), /* @__PURE__ */ t.createElement("div", { className: s.formInputContainer }, /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement(
    B,
    {
      apiKey: g.apiKey,
      country: g.country,
      onPlaceSelected: (d) => u("place", d),
      place: n.place ?? void 0,
      design: {
        backgroundColor: (r == null ? void 0 : r.design.colors.general.highlightBackground) ?? "#000",
        textColor: (r == null ? void 0 : r.design.colors.general.highlightText) ?? "#FFF",
        labelColor: (r == null ? void 0 : r.design.colors.general.highlightHighlight) ?? "#FFF"
      },
      texts: {
        label: (e == null ? void 0 : e.autocomplete_label) || o("autocomplete.label") || void 0,
        placeholder: (e == null ? void 0 : e.autocomplete_placeholder) || o("autocomplete.label") || void 0,
        geolocation: (e == null ? void 0 : e.autocomplete_geolocation) || o("autocomplete.geolocation") || void 0
      },
      storePrefix: P(),
      coordinates: N
    }
  ), n.place && !C && /* @__PURE__ */ t.createElement(
    "div",
    {
      className: s.error,
      style: {
        color: r == null ? void 0 : r.design.colors.general.highlightErrors
      }
    },
    /* @__PURE__ */ t.createElement("i", { className: "lni-warning" }),
    " ",
    (e == null ? void 0 : e.error_missing_street) || o("shopLanding.address.error.missingStreet")
  )), /* @__PURE__ */ t.createElement(
    w,
    {
      label: (e == null ? void 0 : e.address_label) || o("shopLanding.address.label"),
      placeholder: (e == null ? void 0 : e.address_placeholder) || o("shopLanding.address.placeholder"),
      design: {
        textColor: (r == null ? void 0 : r.design.colors.general.highlightText) ?? "#FFF",
        labelColor: (r == null ? void 0 : r.design.colors.general.highlightHighlight) ?? "#FFF"
      },
      value: n.addressInfo ?? "",
      onChange: (d) => u("addressInfo", d.target.value),
      testId: "ordering-floor-input"
    }
  ), ((A = a.address) == null ? void 0 : A.textError) && /* @__PURE__ */ t.createElement(
    "div",
    {
      className: s.error,
      style: {
        color: r == null ? void 0 : r.design.colors.general.highlightErrors
      },
      dangerouslySetInnerHTML: {
        __html: a.address.textError
      }
    }
  ), /* @__PURE__ */ t.createElement("div", { className: s.buttonContainer }, /* @__PURE__ */ t.createElement(
    "button",
    {
      disabled: h,
      id: "takeaway_btn",
      style: {
        display: b ? "block" : "none",
        backgroundColor: r == null ? void 0 : r.design.colors.general.secondaryButtonBackground,
        color: r == null ? void 0 : r.design.colors.general.secondaryButtonText
      },
      className: s.button,
      onClick: () => y(p.TAKEAWAY),
      type: "button",
      "data-testid": "ordering-pickup-button"
    },
    (e == null ? void 0 : e.pickup_button) || o("pickup")
  ), /* @__PURE__ */ t.createElement(
    "button",
    {
      disabled: h,
      id: "delivery",
      style: {
        display: _ || I ? "block" : "none",
        backgroundColor: r == null ? void 0 : r.design.colors.general.primaryButtonBackground,
        color: r == null ? void 0 : r.design.colors.general.primaryButtonText
      },
      className: s.button,
      type: "button",
      onClick: () => y(p.DELIVERY),
      "data-testid": "ordering-delivery-button"
    },
    (e == null ? void 0 : e.delivery_button) || o("delivery")
  ))));
}
export {
  X as default
};
//# sourceMappingURL=AddressStep.js.map
